"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _buildingSevice = require("@/api/building-sevice.api");
var _vuePropertyDecorator = require("vue-property-decorator");
var _BuildingServiceImport = _interopRequireDefault(require("./BuildingServiceImport.vue"));
var _ServiceItem = _interopRequireDefault(require("./ServiceItem.vue"));
var BuildingService = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BuildingService, _Vue);
  var _super = (0, _createSuper2.default)(BuildingService);
  function BuildingService() {
    var _this;
    (0, _classCallCheck2.default)(this, BuildingService);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildingServices", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "services", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "total", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    return _this;
  }
  (0, _createClass2.default)(BuildingService, [{
    key: "handleQuery",
    value: function handleQuery() {
      this.fetchData();
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      this.$refs.BuildingServiceImport.$refs.BuildingAddServiceModal.handleOpen(this.services);
    }
  }, {
    key: "handleClickService",
    value: function handleClickService(service) {
      this.$refs.BuildingServiceImport.$refs.BuildingServiceModal.handleUpdate(service);
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _buildingSevice.buildingServiceApi.findAll({
                  buildingIds: [this.buildingId],
                  isActive: true
                });
              case 2:
                res = _context.sent;
                this.buildingServices = res.data.buildingServices;
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return BuildingService;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], BuildingService.prototype, "buildingId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("buildingId", {
  immediate: true
})], BuildingService.prototype, "handleQuery", null);
BuildingService = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ServiceItem: _ServiceItem.default,
    BuildingServiceImport: _BuildingServiceImport.default
  }
})], BuildingService);
var _default = BuildingService;
exports.default = _default;